






























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import headerTip from './header-tip/index.vue';
@Component({
  components: { headerTip }
})
export default class FastLink extends Vue {
  @Getter('user/resources')
  resources: any[] = [];

  LONG_RENTAL_CAR_NEW: any;
  APPOINTMENT_RECORD: any;
  HAND_LIFT_RECORD: any;
  COUPON_LIST: any;
  CAR_LIST: any;

  created(): void {
    this.LONG_RENTAL_CAR_NEW = this.resources.find(i => i.id == 131);
    this.APPOINTMENT_RECORD = this.resources.find(i => i.id == 139);
    this.HAND_LIFT_RECORD = this.resources.find(i => i.id == 110);
    this.COUPON_LIST = this.resources.find(i => i.id == 165);
    this.CAR_LIST = this.resources.find(i => i.id == 137);
  }
}
